module.exports = __webpack_public_path__ + "img/20210720_185039.db35d8cd.jpg";